import React from "react";
import { motion } from "framer-motion";

export const Section = ({ children, className = "" }) => (
  <section className={`max-w-7xl mx-auto px-5 sm:px-8 ${className}`}>{children}</section>
);

export const Overline = ({ children }) => (
  <span className="overline uppercase text-xs font-semibold text-gold">{children}</span>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: "easeOut" }}
    className={className}
  >
    {children}
  </motion.div>
);
